import {CustomerTypeEnum} from '@c2b/muven-commons'

export class CustomerModel {
    id?:number = undefined;
    email:string = '';
    tradeName:string = '';
    firstName:string = '';
    lastName:string = '';
    phone:string = '';
    corporateName:string = '';
    corporatePhone:string = '';
    stateInscription:string = '';
    type:CustomerTypeEnum = CustomerTypeEnum.Natural;
    document:string = '';
    documentType?:string = undefined;

    constructor(c?:Partial<CustomerModel>) {
        Object.assign(this, c);
    }

    isNatural():boolean {
        return this.type === CustomerTypeEnum.Natural
    }

    isLegal():boolean {
        return this.type === CustomerTypeEnum.Legal
    }

    hasNaturalInfo():boolean {
        return !!this.firstName
    }

    hasLegalInfo():boolean {
        return !!this.corporateName
    }

    fullName():string {
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName}`.trim()
        }

        if (this.firstName && !this.lastName) {
            return `${this.firstName}`.trim()
        }

        if (!this.firstName && this.lastName) {
            return `${this.lastName}`.trim()
        }

        return ''
    }
}
